import axios from 'axios';

const api = axios.create({
  baseURL: 'https://backend.tracker.turtton.ru/api',
  // baseURL: 'http://localhost:5001/api',
  withCredentials: true
});

api.interceptors.request.use(cfg => {
  const token = localStorage.getItem('token');
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

api.interceptors.response.use(
  res => res.data,
  err => {
    if (err.response?.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export default api;